import api from './index';

export const apiGetProProfile = async (userId) => {
  try {
    const { data } = await api.get(`/business/profile/${userId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetProPortfolio = async (userId) => {
  try {
    const { data } = await api.get(`/business/portfolio?user_id=${userId}`);
    return data;
  } catch (error) {
    throw error;
  }
};
